import React from "react";
import { Link } from "react-router-dom";

import { PrimaryButton } from "../../components";

export const PageNotFound: React.FC = () => {
  return (
    <div className="flex-1 bg-gray-50 flex flex-col justify-center items-center px-8 w-full h-full">
      <div className="flex flex-col items-center text-center max-w-md">
        <h2
          className="font-bold text-2xl text-gray-900"
          data-testid="code-heading"
        >
          Not Found 404
        </h2>
        <p
          className="pt-5 text-gray-700 leading-relaxed text-base font-light mb-4"
          data-testid="message-text"
        >
          We&apos;re sorry, the page you requested could not be found.
          <br />
          Please check the URL or go back to the homepage.
        </p>
        <p
          className="text-gray-700 text-base font-light mb-8"
          data-testid="support-text"
        >
          Contact Support for{" "}
          <a
            href="mailto:support@rebootmotion.com"
            className="text-blue-600 underline hover:text-blue-800"
          >
            help
          </a>
          .
        </p>
        <PrimaryButton>
          <Link to="/" data-testid="home-link">
            Go to Home
          </Link>
        </PrimaryButton>
      </div>
    </div>
  );
};
